export class SearchBoderRequestDetailModel {
  public name: string;
  public country: string;
  public status: string;


  constructor(name: string, country: string, status: string) {
    this.name = name;
    this.country = country;
    this.status = status;
  }
}
